class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.searchButtons = this.querySelectorAll('.search-Button');
    
    // Check if this search element is in the mobile menu drawer
    this.isMobileSearch = this.closest('.snippet-menu-drawer') !== null;
    
    // Only apply new functionality to mobile search
    if (this.isMobileSearch) {
      this.initializeMobilePlaceholder();
      this.initializeMobileSearchButton();
      this.addMobileEventListeners();
    } else {
      // Keep original functionality for desktop
      this.addDesktopEventListeners();
    }
  }
  
  initializeMobilePlaceholder() {
    const defaultPlaceholder = this.input.getAttribute('data-default-placeholder') || 'Search…';
    const focusPlaceholder = this.input.getAttribute('data-focus-placeholder') || 'Type here…';
    
    // Set default placeholder if not already set
    if (!this.input.placeholder || this.input.placeholder === '') {
      this.input.placeholder = defaultPlaceholder;
    }
  }
  
  initializeMobileSearchButton() {
    // Set initial disabled state for mobile search buttons only
    this.searchButtons.forEach(button => {
      button.disabled = true;
    });
  }
  
  addMobileEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      this.updateMobileSearchButtonState();
    }, 300).bind(this));
    
    // Handle focus and blur events for placeholder text
    this.input.addEventListener('focus', this.handleMobileFocus.bind(this));
    this.input.addEventListener('blur', this.handleMobileBlur.bind(this));
    
    // Handle Enter key press
    this.input.addEventListener('keypress', this.handleMobileKeyPress.bind(this));
  }
  
  addDesktopEventListeners() {
    // Original desktop functionality - only target search buttons within this element
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length > 0){
        this.searchButtons.forEach(function(SearchButtons){
          SearchButtons.disabled = false;
        });
      } else {
        this.searchButtons.forEach(function(SearchButtons){
          SearchButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  
  handleMobileFocus() {
    const focusPlaceholder = this.input.getAttribute('data-focus-placeholder') || 'Type here…';
    this.input.placeholder = focusPlaceholder;
  }
  
  handleMobileBlur() {
    if (this.input.value.trim() === '') {
      const defaultPlaceholder = this.input.getAttribute('data-default-placeholder') || 'Search…';
      this.input.placeholder = defaultPlaceholder;
    }
  }
  
  handleMobileKeyPress(event) {
    if (event.key === 'Enter' && this.input.value.trim().length > 0) {
      event.preventDefault();
      this.performMobileSearch();
    }
  }
  
  updateMobileSearchButtonState() {
    const hasContent = this.input.value.trim().length > 0;
    // Only update mobile search buttons (within this element)
    this.searchButtons.forEach(button => {
      button.disabled = !hasContent;
    });
  }
  
  performMobileSearch() {
    if (this.input.value.trim().length > 0) {
      this.querySelector('form').submit();
    }
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=5&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector("body").classList.add("predective-search-active")
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector("body").classList.remove("predective-search-active")
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
const showDialog = () => {
const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  // console.log("scrolly-open",scrollY);
  const body = document.body;

  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;

  var Height_announce = 0;
  var announcementBAr_main = document.querySelector("#shopify-section-announcement-bar");
    if(announcementBAr_main){
      Height_announce = announcementBAr_main.clientHeight;
    }
    if(scrollY== "0" ){
    document.querySelector(".section-header").style.top = Height_announce+'px';
  }else{
    document.querySelector(".section-header").style.top = "0";
  }
};
const closeDialog = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  // document.getElementById('dialog').classList.remove('show');
  document.querySelector(".section-header").style.top = "0";
}
var topScroll;
window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
  topScroll = document.documentElement.style.getPropertyValue('--scroll-y');
  if(window.scrollY > 0){
    var Top_HeighT = document.querySelector(".section-header").clientHeight;
    document.querySelector(".snippet-menu-drawer").style.top = Top_HeighT + "px";
    document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+Top_HeighT+"px)";
    document.querySelector(".wish_list_message").style.top = Top_HeighT + "px";
    document.querySelector('.add_cart_message').style.top = "61px"
  } else {
    document.querySelector('.add_cart_message').style.top = "0"
  }
  
});


customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    var Announce_height = 0;
    var announcementBAr = document.querySelector("#shopify-section-announcement-bar");
    if(announcementBAr){
      Announce_height = announcementBAr.clientHeight;
    }
    var TOp_Height = document.querySelector(".section-header").clientHeight;
    var total_height = Announce_height + TOp_Height;
    var scroll_top_height = total_height;
  document.querySelector(".snippet-menu-drawer").style.top = total_height + "px";
  document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+total_height+"px)";
  // document.querySelector(".snippet-menu-drawer").style.paddingBottom = total_height + "px";
  
  menuBurger.addEventListener('click',function(e){

    const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
    var Announce_height = 0;
    var announcementBAr = document.querySelector("#shopify-section-announcement-bar");
    if(announcementBAr){
      Announce_height = announcementBAr.clientHeight;
    }
    var TOp_Height = document.querySelector(".section-header").clientHeight;
    var total_height = Announce_height + TOp_Height;
    var scroll_top_height = total_height;
    // console.log("scroll Y",scrollY)
    // console.log("topScroll",topScroll)
    if(scrollY == "0"){
      total_height = scroll_top_height;
      // console.log(total_height)
      // console.log("0 if")
    }else{
    // console.log("1 else")
      var TOp_Height = document.querySelector(".section-header").clientHeight;
      total_height = TOp_Height;
      // console.log(total_height)
    }
    document.querySelector(".snippet-menu-drawer").style.top = total_height + "px";
    document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+total_height+"px)";
    // document.querySelector(".snippet-menu-drawer").style.paddingBottom = total_height + "px";
    document.querySelector(".wish_list_message").style.top = total_height + "px";
    document.querySelectorAll(".navmobile-dropdown").forEach(function(evtt){
      var totalHEOGHTKP = total_height+"px";
      // evtt.style.height = "calc(100% - "+totalHEOGHTKP+")";
    })
    
    this.classList.toggle("active")
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('html').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');
    if(document.querySelector('body').classList.contains('open-menu')){
      showDialog()
    }else{
      closeDialog()
    }

  });
  
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    this.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add("subdrawer-active");      

    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li.mega-list').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
      document.body.classList.add("active-megamenu");
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
      document.body.classList.remove("active-megamenu");
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};

// additonal custom js starts from here
if(window.innerWidth > 768){
  if(document.querySelector(".brand-filter-loist")){
   document.querySelector(".brand-filter-loist").classList.add("active"); 
  }
}
// header search bar js start sfrom here

var get_search_icon = document.querySelector(".search-Button_forshow");
//console.log(get_search_icon,"get_search_icon");
get_search_icon.addEventListener('click',function(e){
  e.preventDefault();
  document.getElementById("Search").style.display="block";
  document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="16px";
  this.parentElement.parentElement.parentElement.style.width="300px";
  document.getElementById("Search").focus();
});
document.body.addEventListener("click", function (evt) {
  var get_search_icon = document.querySelector(".search-Button_forshow").querySelector("svg");
  var SearchInput = document.getElementById("Search");
  if(evt.target == SearchInput || evt.target == get_search_icon || evt.target == get_search_icon){
    document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="16px";
    document.getElementById("Search").style.display="block";
  }else{
    document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="0";
    document.getElementById("Search").style.display="none";
  }
});



// ====================================== custom js starts from here //////////////////
// document.addEventListener('DOMContentLoaded', (event) => {
//   setTimeout(function(){ 
//     var All_color_swatch = document.querySelectorAll(".color-swatch-design");
//     All_color_swatch.forEach(function (item, idx) {
//           item.addEventListener('click', function (it) {
//               var Get_All_images = this.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".grid-imagebox").querySelectorAll(".product-images img");
//               var THISDATAVAL = this.getAttribute("data-value");
//               var ChangeHtml = this.parentElement.parentElement.parentElement.parentElement.querySelector(".color_option_selected_show");
//               var element = [];
//               var ELE 
//               function checkAge(number) {
//                 return number > 0;
//               }
//             Get_All_images.forEach(function(e){
//                 if(e.getAttribute("data-title") == THISDATAVAL){
//                   e.style.display="block";
//                   ELE = 0;
//                 }
//                 else{
//                   e.style.display="none";
//                  ELE = 1;
//                 }
//               element.push(ELE)
//             })
//             if(element.every(checkAge) == true){
//               Get_All_images[0].style.display = "block";
//             }
//             ChangeHtml.innerHTML = THISDATAVAL;
//           });
//       });
//     }, 2000);
//   });

// ======================== footer section accordion js starts from here =========================
if(window.innerWidth < 992){
  var footerAccordionParent = document.querySelectorAll(".footer-navigation");
  // console.log("accordion working",footerAccordionParent)
  footerAccordionParent.forEach(function(e){
    e.addEventListener("click",function(){
      var ULIST = this.querySelector("ul");
      // console.log(ULIST,ULIST.classList.contains("accorion_active"))
      if(ULIST.classList.contains("accorion_active")){
      //    document.querySelectorAll(".footer_accordion_menu_main").forEach(function(e){
      //   e.classList.remove("accorion_active")
      // })
        // console.log("remove class")
      this.querySelector("ul").style.height = "0px"
        this.querySelector("h6").classList.remove("rotate_active");
        this.querySelector("ul").addEventListener('transitionend', () => {
        	this.querySelector("ul").classList.remove('accorion_active')
        }, {once: true})
        
      }else{
      //    document.querySelectorAll(".footer_accordion_menu_main").forEach(function(e){
      //   e.classList.remove("accorion_active")
      // })
        // console.log("addclass")
        this.querySelector("ul").style.height = "auto";
        this.querySelector("ul").classList.add("accorion_active");
        this.querySelector("h6").classList.add("rotate_active");
        var Accordion_height = this.querySelector("ul").clientHeight + "px";
        this.querySelector("ul").style.height = "0px"
        setTimeout(() => {
            this.querySelector(".accorion_active").style.height = Accordion_height;
        }, 0) 
      }
    });
  })
}

// megamenu js strtas from here

document.querySelectorAll(".megamenu_backarow").forEach(function(e){
    e.addEventListener("click",function(){
        this.parentElement.parentElement.parentElement.parentElement.classList.remove("active");
      this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove("subdrawer-active");
    });
});



// custom filter js starts from here
// console.log("javascript loaded")
// if(window.innerWidth <= 768){
//   if(document.querySelector(".brand-filter-loist")){
//     document.querySelector(".brand-filter-loist").classList.remove("active");
//   }
// }
function toggleFilter(classname){
      document.querySelector(classname).addEventListener("click",function(e){
        e.preventDefault(), e.stopImmediatePropagation();
        this.classList.toggle("active");
    });
}
 // document.querySelectorAll(".facet-list h4").forEach(function(e){
 //   e.addEventListener("click",function(event){
 //     event.preventDefault(), event.stopImmediatePropagation();
 //     console.log("parent")
 //    this.parentElement.classList.toggle("active");
 //  });
 // })

// if(document.querySelector(".collection_sorting")){
//   document.querySelector(".collection_sorting").addEventListener("click",function(e){
//     e.preventDefault(), e.stopImmediatePropagation();
//         this.parentElement.parentElement.classList.toggle("active");
//     });
// }


if(document.querySelector(".filter-box h4") != null){
toggleFilter(".filter-box h4");
}

if(document.querySelector(".filter-sort") != null){
  var ONloadVlau = document.querySelector(".filter-sort ul li.active").querySelector("label .label_span_val").innerHTML;
  document.querySelector(".sorting_value").innerHTML = ONloadVlau;
  document.querySelectorAll("input[name='sort_by']+label").forEach(function(e){
    e.addEventListener("click",function(event){
      // event.preventDefault(), event.stopImmediatePropagation();
        var Value = e.querySelector(".label_span_val").innerHTML;
        document.querySelector(".sorting_value").innerHTML = Value;
    })
  })
}

// if(document.querySelector(".mobile-filter-short") != null){
//   var MobileLoadVal = document.querySelector(".mobile-filter-short ul li.active").querySelector("label .label_span_val").innerHTML;
//     console.log("MobileLoadVal",MobileLoadVal,document.querySelector(".sorting-value-mobile"))
//     document.querySelector(".sorting-value-mobile").innerHTML = MobileLoadVal;
//     document.querySelectorAll("input[name='sort_by_1']+label").forEach(function(e){
//       e.addEventListener("click",function(){
//           var Value = e.querySelector(".label_span_val").innerHTML;
//           document.querySelectorAll(".sorting_value")[0].innerHTML = Value;
//       })
//   })
// }

// search filter js starts from here

if(document.querySelector(".brand_filter_search") != null){
document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keypress",function(e){
    setTimeout(function(){
    var NextInput = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
    // console.log(NextInput)
    var SearchValue = e.target.value.toLowerCase();
    var key = e.which || e.keyCode || e.charCode;
    // console.log(SearchValue,key)
        NextInput.forEach(function(event){
        var FilterValue = event.querySelector("input").dataset.filtervalue;
            if (FilterValue.indexOf(SearchValue) > -1) {
            event.style.display = "block";
            } else {
            event.style.display = "none";
            }
        })
    }, 0);
});
document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keydown",function(e){
    var key = event.keyCode || event.charCode;
    var NextLi = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
  // console.log(NextLi)
    setTimeout(function(){
        if( key == 8 || key == 46 ){
            if(e.target.value == ""){
                NextLi.forEach(function(event){
                    event.style.display="block"
                })
                // console.log("backspace",e.target.value)
            }
        }
     }, 0);
});
}

// product page complete-thelook section css starts from here

function completeTheLook(){
  var LookSLider=[];
  document.querySelectorAll('.complete-the-look-swiper').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.complete-the-look-main-slider');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject={
      loop:eval(Element.dataset.loop),
      slidesPerView: "auto",
      navigation: {
        nextEl:nextbutton,
        prevEl:prevbutton,
      },
    };    
    LookSLider[productid]=new Swiper(Element,swiperObject);
  });
}
completeTheLook();
// console.log("load")




var size_chart_btn = document.querySelector(".choose-selector a");
if(size_chart_btn != null){
  size_chart_btn.addEventListener("click",function(e){
    e.preventDefault();
   this.parentElement.parentElement.parentElement.parentElement.querySelector(".size-chart-main-div").classList.add("active")
    document.body.classList.add("size-chart-open");
  });
  
  document.body.addEventListener("click", function (evt) {
      var match_body_div = document.querySelector("body.size-chart-open");
      var match_size_chart = document.querySelector("body.size-guid-open");
      if(evt.target == match_body_div ){
        document.querySelector(".size-chart-main-div").classList.remove("active")
        document.body.classList.remove("size-chart-open");
      }
      if(evt.target == match_size_chart){
        document.querySelector(".size-guild-message").classList.remove("active");
        document.body.classList.remove("size-guid-open");
      }
  });
  var closeBTN = document.querySelector(".size-chart-close-btn");
  closeBTN.addEventListener("click",function(){
    this.parentElement.parentElement.parentElement.classList.remove("active");
    document.body.classList.remove("size-chart-open");
  });
  var save_variant_btn = document.querySelectorAll(".save-variant-button");
  save_variant_btn.forEach(function(evtt){
    evtt.addEventListener("click",function(){
      this.parentElement.parentElement.parentElement.classList.remove("active");
      document.body.classList.remove("size-chart-open");
    })
  })
  
  // Handle all .pro-labelinr clicks for sold-out and available variants
  var all_variants = document.querySelectorAll(".pro-labelinr.four-vendor");
  all_variants.forEach(function(variant){
    variant.addEventListener("click",function(){
      var addToCartButtons = document.querySelectorAll('.button.product-addcart.button-2');
      
      if(this.classList.contains('sold-out-variant')) {
        // Find the size chart container and close it only for sold-out variants
        if(window.innerWidth < 576) {
          // On smaller screens, close size-chart-parent-var
          var sizeChartParent = document.querySelector(".size-chart-parent-var.active");
          if(sizeChartParent) {
            sizeChartParent.classList.remove("active");
            var blackOverlay = document.querySelector(".black-overlay-mobile");
            if(blackOverlay) {
              blackOverlay.style.display = "none";
            }
            // Check if active class has been removed to restore scrolling
            checkIfActive();
            document.querySelectorAll(".save-variant-button")[2].style.display="block";
            document.querySelector(".show-add-to-cart-button").style.display="none";
            
            // Scroll to the voyado-bis-secondary-container section
            setTimeout(function() {
              var voyadoContainer = document.querySelector(".voyado-bis-secondary-container");
              if(voyadoContainer) {
                voyadoContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }, 100);
          }
        } else {
          // On larger screens, close size-chart-main-div
          var sizeChart = document.querySelector(".size-chart-main-div.active");
          if(sizeChart) {
            sizeChart.classList.remove("active");
            document.body.classList.remove("size-chart-open");
          }
        }

        // Disable button if this element has the sold-out-variant class
        addToCartButtons.forEach(function(button) {
          button.disabled = true;
          var buttonSpan = button.querySelector('span');
          if (buttonSpan) {
            buttonSpan.innerHTML = 'Sold out';
          }
          button.classList.add('sold-out');
        });
      } else {
        // Enable button if this element doesn't have the sold-out-variant class
        addToCartButtons.forEach(function(button) {
          button.disabled = false;
          var buttonSpan = button.querySelector('span');
          if (buttonSpan) {
            buttonSpan.innerHTML = 'Add to cart';
          }
          button.classList.remove('sold-out');
        });
      }
    })
  })
  
  // if(document.querySelectorAll(".save-variant-button")[0]){
  //   console.log("js run")
  // document.querySelectorAll(".save-variant-button")[0].addEventListener("click",function(){
  //   this.parentElement.parentElement.parentElement.classList.remove("active");
  //   document.body.classList.remove("size-chart-open");
  // });
  // }
  // document.querySelectorAll(".save-variant-button")[0].addEventListener("click",function(){
  //   console.log("nkljkl")
  //   this.parentElement.parentElement.parentElement.classList.remove("active");
  //   document.body.classList.remove("size-chart-open");
  // });

  // if(document.querySelector(".notify-me_buton")){
  //   document.querySelector(".notify-me_buton").addEventListener("click",function(){
  //     this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".variant_rsave .save-variant-button").style.display = "none";
  //     this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".variant_rsave .notify-mail-submit").style.display="block";
  //   })
  // }
}

if(document.querySelector(".size_chart_btn")){
  document.querySelector(".size_chart_btn").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.add("active");
    document.body.classList.add("size-guid-open");
  });
  document.querySelector(".size_guild_close").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.remove("active");
    document.body.classList.remove("size-guid-open");
  });

  document.querySelector(".mobile-select-size-variants .size-chart-title").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.add("active");
    document.body.classList.add("size-guid-open");
  });
}


const show_filter = () => {
  // document.getElementById('dialog').classList.add('show')
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
};
const close_filter = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  // document.getElementById('dialog').classList.remove('show');
}

  
if(document.querySelector(".sort-filter-fro-mobile") != null){
  document.querySelector(".sort-filter-fro-mobile").addEventListener("click",function(event){
    event.preventDefault(), event.stopImmediatePropagation();
    this.parentElement.nextElementSibling.querySelector(".collection_filters_main").classList.add("active");
    document.querySelector('body').classList.add('open-filter-popup');
    if(document.querySelector('body').classList.contains('open-filter-popup')){
     show_filter()
    }
  });
}



if(document.querySelector(".back-filter-icon") != null){
  var Back_filter_btn = document.querySelectorAll(".back-filter-icon");
  Back_filter_btn.forEach(function(e){
      e.addEventListener("click",function(event){
        event.preventDefault(), event.stopImmediatePropagation();
          this.parentElement.parentElement.parentElement.classList.remove("active")
      })    
  })
}
if(window.innerWidth > 576){
  if(document.querySelector(".snippet-addto-cart .choose-selector")){
    var Hide_cart_button = document.querySelector(".snippet-addto-cart .choose-selector"); 
    Hide_cart_button.classList.remove("hide-selectore-button");
    // if(Hide_cart_button.classList.contains("hide-selectore-button")){
      
    //    document.querySelector(".snippet-addto-cart .choose-cart").classList.add("hide-selectore-button")
    // }
  }
  if(document.querySelectorAll(".variant-row-list input[name*='Size'], .variant-row-list input[name*='Title']").length > 0){
    document.querySelectorAll(".variant-row-list input[name*='Size'], .variant-row-list input[name*='Title']").forEach(function(e){
          var ValueLIMITdesk
          e.addEventListener("change",function(){
            ValueLIMITdesk = this.value;
            // console.log("ValueLIMITdesk",ValueLIMITdesk)
            document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").classList.add("active");
            document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").innerHTML = ValueLIMITdesk;
          })
      });
  }
  if(document.querySelector(".variant-row-list input[name*='Size']:checked, .variant-row-list input[name*='Title']:checked")){
  var CHecked_value = document.querySelector(".variant-row-list input[name*='Size']:checked, .variant-row-list input[name*='Title']:checked").value;
    document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").classList.add("active");
    document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").innerHTML = CHecked_value;
  }
}

// Define checkIfActive function
const checkIfActive = () => {
  if (document.querySelector(".size-chart-parent-var").classList.contains("active")) {
    // console.log("Class active has been added");
    if(window.innerWidth < 576){
      document.documentElement.classList.add("overflow-hidden");
    }
    } else {
    // console.log("Class active has not been added");
    if(window.innerWidth < 576){
      document.documentElement.classList.remove("overflow-hidden");
    }
  }
};

if(window.innerWidth < 576){
  document.querySelectorAll(".mobile-select-size-variants input[name='Size'], .mobile-select-size-variants input[name='Title'], .mobile-select-size-variants input[name='Shoe Size'], .mobile-select-size-variants input[name='Day']").forEach(function(e){
      e.addEventListener("change",function(){
        var ValueLIMIT = this.value;
        document.querySelector(".product-variant-name").innerHTML =ValueLIMIT;
        var HeightCLLL = document.querySelectorAll(".variant_rsave")[1].clientHeight + 'px';
        // document.querySelector(".size-chart-parent-var.active").style.bottom = HeightCLLL;
        console.log("working")
          if(this.getAttribute("data-value") != 0){
            document.querySelectorAll(".save-variant-button")[2].style.display="none";
            document.querySelector(".show-add-to-cart-button").style.display="block";
            document.querySelector(".mobile-select-size-variants .notify-mail-submit").style.display="none";
          }else{
              document.querySelector(".show-add-to-cart-button").style.display="none";
              document.querySelectorAll(".save-variant-button")[2].style.display="block";
            document.querySelector(".mobile-select-size-variants .notify-mail-submit").style.display="none";
          }
      })
  });
// Get the product handle from the URL. This assumes that the script is running on a product page.
// Get the pathname segments
const pathnameSegments = window.location.pathname.split('/');

// Find the index of the 'products' segment
const productsIndex = pathnameSegments.indexOf('products');

let productHandle;
if (productsIndex !== -1 && productsIndex < pathnameSegments.length - 1) {
  // Get the segment after 'products' as the product handle
  productHandle = pathnameSegments[productsIndex + 1];
  // console.log("porduct handle 1:",productHandle)
}

if (productHandle) {
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {

      if(document.querySelectorAll(".save-variant-button")[2]){
        document.querySelectorAll(".save-variant-button")[2].addEventListener("click", function(){
          console.log("clicked on save-variant 2:",document.querySelectorAll(".save-variant-button")[2].innerHTML);
          // hieronder selecteert het de item variant, staat op default dat de derde item variant is geselecteerd. 707 tm 713, moet dynamisch gegeven worden, als derde item variant sold out is selecteer dan de eerste mogelijke available variant als default
          let selectedVariant = document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked");

          if(selectedVariant){
              let dataValue = parseInt(selectedVariant.getAttribute("data-value"), 10); 
              // parsing as integer; using 10 as the radix parameter to ensure it's parsed as a decimal number
              
              if(dataValue > 0){ // checking if dataValue is positive
                  document.querySelectorAll(".save-variant-button")[2].style.display="none";
                  document.querySelector(".show-add-to-cart-button").style.display="block";
                  document.querySelector(".product-variant-name").innerHTML = selectedVariant.value;
              }
          }
          
          if(window.innerWidth < 576){
            var winHeight = window.screen.height;
            var getScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var FixedTopPosition = '-'+getScrollTop+'px';
            document.documentElement.setAttribute("data-scroll",getScrollTop);
            document.documentElement.style.top=FixedTopPosition;
            document.querySelector(".size-chart-parent-var").style.maxHeight=`calc(${winHeight}px - 218px)`;
          }
          if (product.options[0].values.length > 1) {
            const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
            if(blackOverlayMobile){
              blackOverlayMobile.style.display="block";
            } else {
                // console.error("Element '.black-overlay-mobile' not found");
            }
          document.querySelector(".size-chart-parent-var").classList.add("active");
            checkIfActive(); // Check if active class has been added.
            document.querySelector(".mobile-select-size-variants").classList.add("active");
          } else if ( product.options[0].values.length <= 1) {
          } else { // Failsafe else
            const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
            if(blackOverlayMobile){
              blackOverlayMobile.style.display="block";
            } else {
                // console.error("Element '.black-overlay-mobile' not found");
            }
            document.querySelector(".size-chart-parent-var").classList.add("active");
            checkIfActive(); // Check if active class has been added.
            document.querySelector(".mobile-select-size-variants").classList.add("active");
          }
        });

        document.querySelectorAll(".save-variant-button")[0].addEventListener("click",function(){
          console.log("clicked on save-variant 0:",document.querySelectorAll(".save-variant-button")[0].innerHTML);
          // hieronder selecteert het de item variant, staat op default dat de derde item variant is geselecteerd. 707 tm 713, moet dynamisch gegeven worden, als derde item variant sold out is selecteer dan de eerste mogelijke available variant als default
          if (document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked")) {
            if (document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked").getAttribute("data-value") != 0) {
              document.querySelectorAll(".save-variant-button")[2].style.display="none";
              document.querySelector(".show-add-to-cart-button").style.display="block";
              document.querySelector(".product-variant-name").innerHTML = document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked").value;
            }
          }
          if (product.options[0].values.length > 1) {
            document.querySelector(".size-chart-parent-var").classList.add("active");
            checkIfActive(); // Check if active class has been added.
          } else if ( product.options[0].values.length <= 1) {
          } else {
            document.querySelector(".size-chart-parent-var").classList.add("active");
            checkIfActive(); // Check if active class has been added.
          }
        });
      }
    })
    .catch(err => console.error('Error fetching product:', err));
}

  document.querySelector("body").addEventListener("click",function(e){
      const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
      if(e.target == blackOverlayMobile){
        if(blackOverlayMobile){
          blackOverlayMobile.style.display="none";
        } else {
            console.error("Element '.black-overlay-mobile' not found");
        }
        document.querySelector(".size-chart-parent-var").classList.remove("active");
        checkIfActive(); // Check if active class has been added.
        document.querySelectorAll(".save-variant-button")[2].style.display="block";
        document.querySelector(".show-add-to-cart-button").style.display="none";
        document.querySelector(".mobile-select-size-variants").classList.remove("active");
      if(window.innerWidth < 576){
        if(blackOverlayMobile){
          blackOverlayMobile.style.display="none";
        } else {
            console.error("Element '.black-overlay-mobile' not found");
        }
      // document.querySelector(".product-wrap .product-info").style.zIndex="98";
      var ScrollPosition = Number(document.documentElement.getAttribute("data-scroll"));
      window.scrollTo({ top: ScrollPosition, behavior: 'auto' });
      }
    }
  });
  if(document.querySelector(".mobile_size_close")) document.querySelector(".mobile_size_close").addEventListener("click",function(){
    const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
    document.querySelector(".size-chart-parent-var").classList.remove("active");
    checkIfActive(); // Check if active class has been added.
    document.querySelectorAll(".save-variant-button")[2].style.display="block";
    document.querySelector(".show-add-to-cart-button").style.display="none";
    document.querySelector(".mobile-select-size-variants").classList.remove("active");
    if(blackOverlayMobile){
      blackOverlayMobile.style.display="none";
    } else {
        console.error("Element '.black-overlay-mobile' not found");
    }
    // document.querySelector(".product-wrap .product-info").style.zIndex="98";
    var ScrollPosition = Number(document.documentElement.getAttribute("data-scroll"));
    // console.log("ScrollPosition-->",ScrollPosition)
    window.scrollTo({ top: ScrollPosition, behavior: 'auto' });
  })
  // if(document.querySelector(".notify-me_buton-for-mobile")){
  //   document.querySelectorAll(".notify-me_buton-for-mobile").forEach(function(e){
  //     e.addEventListener("click",function(){
  //       document.querySelectorAll(".save-variant-button")[2].style.display="none";
  //       document.querySelector(".show-add-to-cart-button").style.display = "none"
  //         document.querySelector(".mobile-select-size-variants .notify-mail-submit").style.display="block";
  //       var HeightCLLL = document.querySelectorAll(".variant_rsave")[1].clientHeight + 'px';
  //         document.querySelector(".size-chart-parent-var.active").style.bottom = HeightCLLL;
  //     })
  //   });
  // }

}

// pnroduct page js start sform here

if(document.querySelector(".specificaion-discri")){
  var Specification_height = document.querySelector(".specificaion-discri").clientHeight+"px";
  // console.log(Specification_height)
  document.querySelector(".product-specification .specificaion-discri").style.height = Specification_height;
  document.querySelector(".product-specification h5").addEventListener("click",function(){
    this.parentElement.classList.toggle("close");
  });
}
// if(document.querySelector(".notify-me_buton")){
//   document.querySelectorAll(".notify-me_buton").forEach(function(e){
//       e.addEventListener("click",function(){
//           document.querySelector(".add.klaviyo-bis-trigger").click();
//       })
//   });
//   document.querySelectorAll(".notify-me_buton-for-mobile").forEach(function(e){
//       e.addEventListener("click",function(){
//         document.querySelector(".add.klaviyo-bis-trigger").click();
//         const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
//         if(blackOverlayMobile){
//           blackOverlayMobile.style.display="none";
//         } else {
//             console.error("Element '.black-overlay-mobile' not found");
//         }
//         document.querySelector(".size-chart-parent-var").classList.remove("active");
//         checkIfActive(); // Check if active class has been added.
//         document.querySelector(".mobile-select-size-variants").classList.remove("active");

//         const selectedRadio = document.querySelector(".mobile-select-size-variants input[name='Size']:checked,.mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked"); 
//         selectedRadio.checked = false;

//     })
//   });
// }
if(document.querySelector(".facet-list.filter-index.active")){
  document.querySelector(".facet-list.filter-index.active").classList.remove("active");
}
if(document.querySelector(".show_more_filter")){
  document.querySelector(".show_more_filter").addEventListener("click",function(){
    this.parentElement.nextElementSibling.classList.toggle("active");
    this.classList.toggle("active");
    // console.log("click occur")
  })
}


function collectionscroll(){
  var TOPTOP = document.querySelector(".sorting-button-formobile").offsetTop;
  document.addEventListener('scroll',function(){
    if(document.documentElement.scrollTop > TOPTOP ){
      document.querySelector(".sorting-button-formobile").classList.add("sticky-collection")
      document.querySelector(".sticky-collection").querySelector(".sort-filter-fro-mobile").classList.remove("Button-1")
    }else{
      document.querySelector(".sorting-button-formobile").classList.remove("sticky-collection")
      document.querySelector(".sorting-button-formobile").querySelector(".sort-filter-fro-mobile").classList.add("Button-1")
    }
  });
}
if(document.querySelector(".sorting-button-formobile") && document.querySelector(".raffel-collection-filter-btn-mobile") == null){
  collectionscroll();
}

// function productAddCart(){
//   var MediaHEight = document.querySelector(".product-media").clientHeight;
//   var InfoHeight = document.querySelector(".product-info .infor-inner-main").clientHeight;
//   var HeightFifference = MediaHEight - InfoHeight;
//   var Add_Button = document.querySelectorAll(".choose-selector a")[0].offsetTop + HeightFifference + 57 + 30 + 100;
//   document.addEventListener('scroll',function(){
//     if(document.documentElement.scrollTop > Add_Button ){
//       console.log(document.documentElement.scrollTo,Add_Button,document.querySelectorAll(".product-addcart")[1])
//       document.querySelectorAll(".choose-selector a")[0].classList.add("sticky-Product")
//       document.querySelectorAll(".choose-selector a")[0].classList.remove("button-2")
//     }else{
//       document.querySelectorAll(".choose-selector a")[0].classList.remove("sticky-Product")
//       document.querySelectorAll(".choose-selector a")[0].classList.add("button-2")
//     }
//   });
// }

// function Remove_StickyClass(){
//   var RemoveAdd_Button = document.querySelector(".Product-recomndation-section-pdp").offsetTop;
//   document.addEventListener('scroll',function(){
//     if(document.documentElement.scrollTop > RemoveAdd_Button ){
//       document.querySelectorAll(".choose-selector a")[0].classList.remove("sticky-Product")
//       document.querySelectorAll(".choose-selector a")[0].classList.add("button-2")
//     }
//   });
// }

if(window.innerWidth > 991){
  if(document.querySelectorAll(".choose-selector a")[0] && document.querySelector(".Product-recomndation-section-pdp")){
     productAddCart();
    Remove_StickyClass();
  }
}

 document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
     //if esc key was not pressed in combination with ctrl or alt or shift
        const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
        if (isNotCombinedKey) {
          if(document.querySelector(".size-chart-main-div.active")){
             document.querySelector(".size-chart-main-div.active").classList.remove("active"); 
            document.body.classList.remove("size-chart-open");
          }
          if( document.querySelector(".size-guild-message.active")){
          document.querySelector(".size-guild-message").classList.remove("active");
          document.body.classList.remove("size-guid-open");
          }
        }
      if(document.body.classList.contains("predective-search-active")){
        document.body.classList.remove("predective-search-active");
        document.getElementById("predictive-search").style.display="none";
      }
    }
  });
document.body.addEventListener("click",function(evt){
    if(document.body.classList.contains("predective-search-active")){
     document.body.classList.remove("predective-search-active");
    document.getElementById("predictive-search").style.display="none";
    }
})


// sticky slecte size starts from here
  if(document.querySelector(".mobile-select-size-variants")){
  var product_section_footer = document.querySelector("#shopify-section-footer").offsetTop + 200;
  document.addEventListener('scroll',function(){
    if(document.documentElement.scrollTop > product_section_footer ){
      document.querySelector(".mobile-select-size-variants").style.position= "inherit";
    }else{
      document.querySelector(".mobile-select-size-variants").style.position= "fixed";
    }
    // if(document.documentElement.scrollTop > RemoveAdd_Button ){
    //   document.querySelectorAll("").classList.remove("sticky-Product")
    //   document.querySelectorAll("").classList.add("button-2")
    // }
  });
  }

// swym wishlist popup js starts from here


function swymCallbackFn(swat) {
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function(event) {
    document.querySelector(".wish_list_message .remove_message").style.display = "none";
    document.querySelector(".wish_list_message .add_message").style.display = "inline-block";
     document.querySelector(".wish_list_message").style.display = "block";
      setTimeout(function(){
        document.querySelector(".wish_list_message").style.display = "none";
      }, 2000);
  });
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function(event) {
     document.querySelector(".wish_list_message .remove_message").style.display = "inline-block";
    document.querySelector(".wish_list_message .add_message").style.display = "none";
    document.querySelector(".wish_list_message").style.display = "block";
      setTimeout(function(){
        document.querySelector(".wish_list_message").style.display = "none";
      }, 2000);
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);